import React from 'react';
import useStreamingList from '@a2d24/deadpoll/react/useStreamingList';
import rootStore from '@a2d24/care-at-work-state/stores';

const useDeadpollList = (identifier) => {
    return useStreamingList(identifier, { client: rootStore.deadpollStore.deadpollClient });
};

export default useDeadpollList;
